import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "language-picker" }
const _hoisted_2 = { class: "language-picker__value" }

import { computed, onBeforeMount, ref } from "vue";
import { useAppStore } from "@app/Store/app-store";
import { useApi } from "@shared/Services/axios-service";
import Dropdown from "@shared/Components/Dropdown/Dropdown.vue";

type LanguageItem = {
  code: string;
  name: string;
  url: string;
};

type LanguagesResponse = {
  currentLanguage: string;
  languageItems: LanguageItem[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguagePicker',
  setup(__props) {

const LANGUAGE_CODES = {
  English: "EN",
  German: "DE",
  Swedish: "SV",
} as const;

const LANGUAGE_LOCALE_BY_CODE: Record<string, string> = {
  [LANGUAGE_CODES.English]: "en-US",
  [LANGUAGE_CODES.German]: "de-DE",
  [LANGUAGE_CODES.Swedish]: "sv-SE",
};
const DEFAULT_LANGUAGE_LOCALE = LANGUAGE_LOCALE_BY_CODE[LANGUAGE_CODES.Swedish];

const appStore = useAppStore();
const { data: languagesData, get: getLanguages } = useApi<LanguagesResponse>("/layout/languages");
const currentLanguage = ref("");

const availableLanguages = computed(() =>
  languagesData.value?.languageItems.map((item) => item.code) ?? []
);

onBeforeMount(async () => {
  const response = await getLanguages().catch(() => undefined);
  if (!response?.currentLanguage) {
    return;
  }

  currentLanguage.value = response.currentLanguage;
  saveCurrentLanguage(currentLanguage.value);
});

function goToLanguage(): void {
  const selectedLanguage = languagesData.value?.languageItems.find((item) => item.code === currentLanguage.value);
  if (!selectedLanguage?.url) {
    return;
  }

  saveCurrentLanguage(currentLanguage.value);
  window.location.replace(new URL(selectedLanguage.url, window.location.origin).toString());
}

function saveCurrentLanguage(lang: string): void {
  appStore.setCurrentLanguage(getLanguageString(lang));
}

function getLanguageString(lang: string): string {
  return LANGUAGE_LOCALE_BY_CODE[lang] ?? DEFAULT_LANGUAGE_LOCALE;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Dropdown, {
      class: "language-picker__dropdown",
      modelValue: currentLanguage.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentLanguage).value = $event)),
      "aria-label": "Language",
      options: availableLanguages.value,
      onOnSelect: goToLanguage
    }, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "icon icon--globe language-picker__icon",
          "aria-hidden": "true"
        }, null, -1 /* CACHED */)),
        _createElementVNode("span", _hoisted_2, _toDisplayString(currentLanguage.value), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "options"])
  ]))
}
}

})